import React from 'react';
import { Link } from 'react-router-dom';

const requestTypes = [
  {
    icon: (
      <span className="material-icons text-blue-500 text-4xl bg-blue-100 rounded-full p-2">brush</span>
    ),
    title: 'Graphic Design',
    desc: 'Logos, flyers, posters, social posts, infographics',
    slug: 'graphic-design',
  },
  {
    icon: (
      <span className="material-icons text-purple-500 text-4xl bg-purple-100 rounded-full p-2">web</span>
    ),
    title: 'Web Design',
    desc: 'Landing pages, microsites, website mockups',
    slug: 'web-design',
  },
  {
    icon: (
      <span className="material-icons text-orange-500 text-4xl bg-orange-100 rounded-full p-2">design_services</span>
    ),
    title: 'UI/UX Design',
    desc: 'App flows, wireframes, user journeys',
    slug: 'ui-ux-design',
  },
  {
    icon: (
      <span className="material-icons text-green-500 text-4xl bg-green-100 rounded-full p-2">branding_watermark</span>
    ),
    title: 'Branding',
    desc: 'Brand guides, visual identity, assets',
    slug: 'branding',
  },
  {
    icon: (
      <span className="material-icons text-yellow-500 text-4xl bg-yellow-100 rounded-full p-2">brush</span>
    ),
    title: 'Illustration',
    desc: 'Custom illustrations, icons, assets',
    slug: 'illustration',
  },
  {
    icon: (
      <span className="material-icons text-pink-500 text-4xl bg-pink-100 rounded-full p-2">slideshow</span>
    ),
    title: 'Presentation Design',
    desc: 'Pitch decks, slides, keynote, PowerPoint',
    slug: 'presentation-design',
  },
  {
    icon: (
      <span className="material-icons text-teal-500 text-4xl bg-teal-100 rounded-full p-2">code</span>
    ),
    title: 'Web Development',
    desc: 'Front-end, landing pages, integrations',
    slug: 'web-development',
  },
  {
    icon: (
      <span className="material-icons text-indigo-500 text-4xl bg-indigo-100 rounded-full p-2">email</span>
    ),
    title: 'Email Development',
    desc: 'Custom, responsive email templates',
    slug: 'email-development',
  },
];

const CreateRequest: React.FC = () => {
  return (
    <>
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Create Request</h1>
      </div>
      <h2 className="text-lg font-semibold text-gray-700 mb-6">Choose a Request Type</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {requestTypes.map((type, idx) => (
          <Link
            to={`/dashboard/requests/create/${type.slug}`}
            key={type.slug}
            className="bg-white rounded-xl shadow border p-6 flex flex-col items-center hover:shadow-lg transition cursor-pointer"
          >
            {type.icon}
            <div className="mt-4 font-semibold text-base text-gray-900 text-center">{type.title}</div>
            <div className="mt-1 text-gray-500 text-sm text-center">{type.desc}</div>
          </Link>
        ))}
      </div>
    </>
  );
};

export default CreateRequest; 